"use client";
import Slider from "react-slick";
import { TfiAngleLeft, TfiAngleRight } from "react-icons/tfi";
import { ReactNode } from "react";

export default function SimiliarArticlesSlider({
	children,
}: { children: ReactNode }) {
	const settings = {
		useTransform: false,
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,

		responsive: [
			{
				breakpoint: 1399,
				settings: {
					useTransform: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: false,
				},
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					useTransform: false,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: false,
				},
			},
		],
	};
	// biome-ignore lint/suspicious/noExplicitAny: bad types
	return <Slider {...settings}>{children as unknown as any}</Slider>;
}
const PrevArrow = (props: {
	className?: string;
	style?: string;
	onClick?: () => void;
}) => {
	const { className, style, onClick } = props;

	return (
		<button
			type="button"
			aria-label="Previous Article"
			onClick={onClick}
			className="prev tabindexlink z-[2] absolute top-[50%] left-[-50px] bg-[#1757A3] rounded-full p-[10px]"
		>
			<TfiAngleLeft size={20} color="#fff" />
		</button>
	);
};

const NextArrow = (props: {
	className?: string;
	style?: string;
	onClick?: () => void;
}) => {
	const { className, style, onClick } = props;

	return (
		<button
			type="button"
			aria-label="Next Article"
			onClick={onClick}
			className="next z-[2] tabindexlink absolute top-[50%] right-[-50px] bg-[#1757A3] rounded-full p-[10px]"
		>
			<TfiAngleRight size={20} color="#fff" />
		</button>
	);
};
